import { useFormikContext } from "formik";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useStyles } from "./syles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ChromePicker } from "react-color";
import { useState } from "react";
import TabPanel from "../../TabPanel";
import { LIGHT_GREY } from "../../../utils/colors";
import { CreateFormData } from "../../../types/forms";

export function Colors() {
  const formik = useFormikContext<CreateFormData>();

  const styles = useStyles();
  const [tabSelected, setTabSelected] = useState<number>(0);

  return (
    <>
      <Typography color="primary" marginBottom={2}>
        Cores
      </Typography>
      <div className={styles.root}>
        <div style={{ width: "55%" }}>
          <Tabs
            value={tabSelected}
            onChange={(_, newTab) => setTabSelected(newTab)}
            aria-label="basic tabs example"
            centered
            TabIndicatorProps={{
              style: { display: "none" },
            }}
          >
            <Tab label="Cor de fundo" />
            <Tab label="Cor da fonte" />
          </Tabs>
          <div className={styles.rootContent}>
            <TabPanel value={tabSelected} index={0}>
              <ChromePicker
                color={formik.values.bgColorForm}
                onChangeComplete={(color) =>
                  formik.setFieldValue("bgColorForm", color.hex)
                }
                styles={{
                  default: {
                    picker: {
                      height: "100%",
                      width: "100%",
                      boxShadow: "none",
                      position: "static",
                      border: `1px solid ${LIGHT_GREY}`,
                    },
                  },
                }}
              />
            </TabPanel>
            <TabPanel value={tabSelected} index={1}>
              <ChromePicker
                color={formik.values.fontColorForm}
                onChangeComplete={(color) =>
                  formik.setFieldValue("fontColorForm", color.hex)
                }
                styles={{
                  default: {
                    picker: {
                      height: "100%",
                      width: "100%",
                      boxShadow: "none",
                      position: "static",
                      border: `1px solid ${LIGHT_GREY}`,
                    },
                  },
                }}
              />
            </TabPanel>
          </div>
        </div>
        <div
          className={styles.rootPreview}
          style={{ backgroundColor: formik.values.bgColorForm }}
        >
          <Typography
            fontWeight={900}
            variant="h5"
            marginBottom={2}
            style={{ color: formik.values.fontColorForm }}
          >
            Nome
          </Typography>
          <TextField />
        </div>
      </div>
    </>
  );
}
